import React from 'react';

import { useHeader } from 'hooks';

export default Component => props => {
    const [, actions] = useHeader();
    return <Component {...props} setSearchTitle={actions.setSearchTitle} />;
};
